import { ActionIcon, Checkbox, Group, Text } from "@mantine/core";
import { Edit, Eye, Trash } from "tabler-icons-react";

const renderFieldValue = (row, field, renderFn) => {
  const fieldNames = field.split(".");
  let value = row;

  for (const fieldName of fieldNames) {
    value = value[fieldName] ?? "";
  }

  // Si une fonction de rendu personnalisée est fournie, l'utiliser
  if (renderFn && typeof renderFn === 'function') {
    return <Text weight={600}>{renderFn(value)}</Text>;
  }

  if (fieldNames.length > 0) {
    return <Text weight={600}>{value}</Text>;
  }

  return value;
};

const TableWithPaginationRow = ({
  row,
  updatedFields,
  navigation,
  handleEdit,
  handleDelete,
  selection,
  toggleRow,
  check = false,
  id,
  otherAction,
}) => (
  <tr key={row[updatedFields[0].field]}>
    {check ? (
      <td>
        <Checkbox
          checked={selection.includes(id)}
          onChange={() => toggleRow(id)}
        />
      </td>
    ) : null}
    {updatedFields.map((field, index) => (
      <td key={index + "" + field.field}>
        {renderFieldValue(row, field.field, field.render)}
      </td>
    ))}
    <td style={{ whiteSpace: "nowrap" }}>
      <Group position="right" noWrap spacing={4}>
        {navigation ? (
          <ActionIcon
            color="blue"
            size="md"
            variant="light"
            onClick={() => (!navigation ? null : navigation(`${id}`))}
          >
            <Eye size={18} />
          </ActionIcon>
        ) : null}
        {handleEdit ? (
          <ActionIcon color="green" size="md" variant="light" onClick={() => handleEdit(id, row)}>
            <Edit size={18} />
          </ActionIcon>
        ) : null}
        {handleDelete ? (
          <ActionIcon color="red" size="md" variant="light" onClick={() => handleDelete(id, row)}>
            <Trash size={18} />
          </ActionIcon>
        ) : null}
        {otherAction ? otherAction(row?.id, row) : null}
      </Group>
    </td>
  </tr>
);

export default TableWithPaginationRow;
